import Query from "../../core/query/query";
export class ContactQuery extends Query{
}
